import { Decimal } from 'decimal.js-light';
import { useMemo } from 'react';
import { PaymentRowLogic } from './PaymentRowLogic';

/**
 * Calcola il report di una singola voce di costo.
 */
export function usePaymentRowReport(params: {
  baseUnitAmount: string | null | undefined;
  quantity: number | null | undefined;
  vat: number | null | undefined;
  discount: number | null | undefined;
}) {
  const { baseUnitAmount, quantity, vat, discount } = params;

  const unitAmount = useMemo(() => {
    return PaymentRowLogic.getUnitAmount({
      baseUnitAmount,
      discount,
    });
  }, [baseUnitAmount, discount]);

  // Imponibile
  const taxable = useMemo(
    () =>
      PaymentRowLogic.getTaxableAmount({
        unitAmount,
        quantity,
      }),
    [unitAmount, quantity],
  );

  // Tot IVA
  const vatAmount = useMemo(
    () => PaymentRowLogic.getVatAmount({ taxable, vat }),
    [taxable, vat],
  );

  // Totale
  const total = useMemo(
    () =>
      PaymentRowLogic.getTotalAmount({
        taxable,
        vatAmount,
      }),
    [taxable, vatAmount],
  );

  const totalNoDiscount = useMemo(() => {
    const taxable = PaymentRowLogic.getTaxableAmount({
      unitAmount: baseUnitAmount == null ? null : new Decimal(baseUnitAmount),
      quantity,
    });

    return PaymentRowLogic.getTotalAmount({ taxable, vatAmount });
  }, [baseUnitAmount, quantity, vatAmount]);

  return {
    unitAmount: unitAmount?.toNumber() ?? null,
    taxable: taxable?.toNumber() ?? null,
    vatAmount: vatAmount?.toNumber() ?? null,
    total: total?.toNumber() ?? null,
    totalNoDiscount: totalNoDiscount?.toNumber() ?? null,
  };
}
